export enum AssessmentFrequency {
  BiWeekly = 'Bi-Weekly',
  Monthly = 'Monthly',
  None = 'None',
  Once = 'Once',
  PRN = 'PRN',
  Taper = 'Taper',
  Weekly = 'Weekly',
}
